// extracted by mini-css-extract-plugin
module.exports = {"above-mobile":"551px","loginBtnContainer":"LoginSection-module__loginBtnContainer___2Qol6","loginTitle":"LoginSection-module__loginTitle___3fv6K"};